import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_sales_contract_folder_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fixed_asset_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  sales_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_order_line_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  sales_agent_guid: fromDatatype.GuidDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  contract_no: fromDatatype.VarcharDatatypeInterface;
  subscription_duration_day: fromDatatype.IntegerDatatypeInterface;
  subscription_duration_month: fromDatatype.IntegerDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_sales_contract_folder_hdr_RowClass
  implements bl_fi_sales_contract_folder_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fixed_asset_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  sales_order_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_order_line_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  sales_agent_guid: fromDatatype.GuidDataFieldInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  contract_no: fromDatatype.VarcharDatatypeInterface;
  subscription_duration_day: fromDatatype.IntegerDatatypeInterface;
  subscription_duration_month: fromDatatype.IntegerDatatypeInterface;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
}
